import React from 'react'
import celebration from '../../imgs/fetti.png'
const Congratulations = () => {
    return (
        <div className='h-screen w-screen bg-congrats flex items-center justify-center md:mx-0 px-5'>
            <div className='flex flex-col justify-center items-center '>
                <div className='flex justify-between items-center w-full max-w-[600px] h-auto mb-5'>
                    <div className='md:w-[132.15px] w-[100px]'>
                        <img src={celebration} alt="" className="h-auto w-full object-contain" />
                    </div>
                    <h2 className='font-bold  md:text-[48px] text-[32px] leading-none'>!!!مبروك</h2>
                    <div className='md:w-[132.15px] w-[100px] '>
                        <img src={celebration} alt="" className="h-auto w-full object-contain" />
                    </div>
                </div>
                <div className='mb-10  text-center'>
                    <p> بنجاح “Otlob Coach” لقد قمت بطلب تسجيل حساب على  </p>
                </div>
                <div className='mb-10 text-center'>
                    <p className='font-[600]'>.سيتم إرسال رابط للوصول علي الحساب إليك عبر البريد الإلكتروني خلال 48 ساعة</p>
                </div>
                <div className='mb-10 text-center'>
                    <p>
                        نتطلع إلى استضافتك.
                    </p>
                </div>
                <div className='mb-10 text-center'>
                    <p>
                        !شكرا لك
                    </p>
                </div>
            </div>

        </div>
    )
}

export default Congratulations